export const DATA_EXECUTION_MODE = {
  REALTIME_RAW: 1,
  VIRTUAL_DB_COLUMNS: 2,
  VIRTUAL_DB_MEASURES: 3,
  CLIENT_COLUMNS: 4,
  CLIENT_MEASURES: 5,
  SERVER_COLUMNS: 2,
  SERVER_MEASURES: 3,
};
